<template>
	<!-- <div class="esrimapcomponent" v-show="mapReady"> -->
	<!-- Above line can be used to hide the zooming around until room is shown -->
	<div>		
		<TitleBlock v-if="!showToolbar" /> 
		<Toolbar /> 
		<Loading v-if="!showMap && !showToolbar" />		
		<div class="esrimapcomponent" >
			<div class="controlRack" v-if="showMap" >
				<v-layout column >
					<v-btn small fab @click="zoomIn" class="zoomButton title mb-1">+</v-btn>
					<v-btn small fab @click="zoomOut" class="zoomButton title">-</v-btn>
				</v-layout>
			</div>
			<Elevator v-if="showElevator && mapReady" />
			<div ref="map" id="map" class="map" >
				<div v-if="latLong" style="position: absolute; bottom: 0px; right: 0px;  background-color: #3333FF; z-index: 10; width: 200px; height: 80px;">
					<div style="color: white; padding: 5px 10px 5px 10px; font-size: 8pt; background-color: #0000AA; color: white; text-align: left;">
						Lat / Long
						<div style="float: right; cursor: pointer;" @click="setLatLong(null)">X</div>
					</div>
					<div style="color: white; padding: 20px 15px 20px 10px;" >{{latLong}}</div>	
				</div>

			</div>		
		</div>
		<
	</div>
</template>

<script>

import { loadModules } from 'esri-loader'
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { LODS } from '../lods'
import TitleBlock from '@/components/TitleBlock'
import Toolbar from '@/components/Toolbar'
import Loading from '@/components/Loading'
import Elevator from '@/components/Elevator'

export default {

	mounted: function () {
		if (this.$route.params.bldg) {  }
		this.createMap()
	},

	components: { TitleBlock, Toolbar, Loading, Elevator },

	computed: {
		...mapState({	selectedBuilding: state => state.space.selectedBuilding,
						selectedRoom: state => state.space.selectedRoom,
						buildings: state => state.space.buildings, 
						stateMap: state => state.mapFunctions.stateMap,
						mapReady: state => state.ui.mapReady,
						showToolbar: state => state.ui.showToolbar,
						showMap: state => state.ui.showMap,
						latLong: state => state.ui.latLong,
						showElevator: state => state.ui.showElevator,
					}),

		...mapGetters([ 'getRoom', 'getBuilding', ])
	},


	methods: {
		...mapMutations(['setMap', 'setSelectedRoom', 'setShowToolbar', 'setSelectedBuilding', 'setMapReady', 'setShowMap', 'setLatLong']),
		...mapActions(['loadMapLayers', 'highlightRoom', 'fetchBuildings', 'highlightBuilding', 'findRoom', 'speedHighlightRoom', 'fetchBuilding', 'highlightRoomsByKey', 'labelBuildings']),
		
		createMap: function () {
			loadModules(["esri/map", "esri/layers/LabelLayer", "esri/geometry/webMercatorUtils", "dojo/dom", ])
			.then(([Map, LabelLayer, webMercatorUtils, dom]) => {

				const map = new Map("map", {
							    center: [-110.95344, 32.231877],
							    zoom: 18,
							    lods: LODS,
							    logo: false,
							    smartNavigation: false,
								isZoomSlider: true,
  				})

  				const vm=this

				this.setMap(map)
				this.loadMapLayers()
				if(this.$route.query.topLabels=="true") { this.labelBuildings() }

				map.on("load", async function() { 

					// Highlighting directly to GIS service without any async waiting proves to be faster.  3.5s vs 5.5s
					if (vm.$route.params.bldg) {
						vm.highlightBuilding({ 'bldgAlpha': vm.$route.params.bldg })
						// If we are highlighting building only, show map now.  Otherwise, it will be shown later.	
						if (!vm.$route.params.room)	{ vm.setShowMap(true) }				 
					} 

					if (vm.$route.params.room) { 
						vm.speedHighlightRoom(vm.$route.params.bldg + '+' + vm.$route.params.room)						
					} 

					// After prioritizing any highlighting, load up state, show the Title Block and close the toolbar

					if (vm.$route.params.bldg) {
						// Needed for setSelectBuilding which is dependency for title block
						await vm.fetchBuilding(vm.$route.params.bldg)

						if (vm.$route.params.room) {
							vm.setSelectedRoom({ 'number': vm.$route.params.room })
						}
					}

					//let payload = { roomKeys: ['300A+A104','300A+A106'], color: "rgba(63,81,181, 0.6)", 'floor':"1" }
            		//vm.highlightRoomsByKey(payload)

					// Works.  Might be kind of slow.  Testing with above block
/*					vm.fetchBuildings().then(() => {
						if (vm.$route.params.bldg) {
							vm.highlightBuilding({ 'bldgAlpha': vm.$route.params.bldg })
							vm.setSelectedBuilding(vm.getBuilding(vm.$route.params.bldg)).then(() => {						
								if (vm.$route.params.room) {
									vm.setSelectedRoom(vm.getRoom(vm.$route.params.room))									
									vm.highlightRoom(vm.selectedRoom)
								}
							})
						}
					})	*/				
				})	
			
				map.on("mouse-up", function (evt) {
					if (evt.ctrlKey) {
						var mp = webMercatorUtils.webMercatorToGeographic(evt.mapPoint);
	          			//display mouse coordinates
	          			console.log(mp.x.toFixed(7) + ", " + mp.y.toFixed(7))
	          			vm.setLatLong(mp.x.toFixed(7) + ", " + mp.y.toFixed(7))
	          			//dom.byId("latlonginfo").innerHTML = mp.x.toFixed(5) + ", " + mp.y.toFixed(5);
	          		}
				})

			
				// This stuff makes it so you can do a multiline label with "\n"
				if( typeof esri.layers.LabelLayer.prototype._addLabel == 'function' )
				{
					esri.layers.LabelLayer.prototype._addLabel2 = esri.layers.LabelLayer.prototype._addLabel;
					esri.layers.LabelLayer.prototype._addLabel = function(a,b,c,e,g,k,m)
					{
						// replace \n by <br>
						a = a.replace(/\n/g, "<br />");
						this._addLabel2(a,b,c,e,g,k,m);
					}
				}

				// This stuff makes it so you can do a multiline label with "\n"
				if( typeof dojox.gfx.svg.Text.prototype.setShape == 'function' )
				{
					dojox.gfx.svg.Text.prototype.setShape = function(p)
					{
						this.shape = dojox.gfx.makeParameters(this.shape, p);
						this.bbox = null;
						var r = this.rawNode, s = this.shape;
						r.setAttribute("x", s.x);
						r.setAttribute("y", s.y);
						r.setAttribute("text-anchor", s.align);
						r.setAttribute("text-decoration", s.decoration);
						r.setAttribute("rotate", s.rotated ? 90 : 0);
						r.setAttribute("kerning", s.kerning ? "auto" : 0);
						r.setAttribute("text-rendering", "optimizeLegibility");
						
						while(r.firstChild)
							r.removeChild(r.firstChild);

						if(s.text)
						{ 
							var texts = s.text.replace(/<br\s*\/?>/ig, "\n").split("\n");
							var lineHeight = 1.1 * parseInt(document.defaultView.getComputedStyle(r, "").getPropertyValue("font-size"), 10); 
							if( isNaN(lineHeight) || !isFinite(lineHeight) )
								lineHeight = 15;
								
							for(var i = 0, n = texts.length; i < n; i++)
							{ 
								var tspan = (document.createElementNS ? document.createElementNS(dojox.gfx.svg.xmlns.svg, "tspan") : document.createElement("tspan"));
								tspan.setAttribute("dy", i ? lineHeight : -(texts.length-1)*lineHeight/2); 
								tspan.setAttribute("x", s.x);
								tspan.appendChild((dojox.gfx.useSvgWeb ? document.createTextNode(texts[i], true) : document.createTextNode(texts[i]))); 
								r.appendChild(tspan);
							}
						}

						return this;
					}
				}

			})

		},

		zoomIn(){
		  this.stateMap.setZoom(this.stateMap.getZoom()+1);
		},

		zoomOut(){
		  this.stateMap.setZoom(this.stateMap.getZoom()-1);
		},


	}
}

</script>

<style>
@import url('https://js.arcgis.com/3.23/esri/css/esri.css');
@import url("https://js.arcgis.com/3.25/esri/themes/calcite/dijit/calcite.css");
@import url("https://js.arcgis.com/3.25/esri/themes/calcite/esri/esri.css");

html, body, #map, .esrimapcomponent, .estimapcontainer {
	padding: 0;
	margin: 0;
	height: 100%;
	overflow-y: hidden !important;
	height: 100vh;
}

#map {
}

#map_zoom_slider { display: none; }

.controlRack {
	position: absolute;
	top: 120px;
	left: 10px;
	z-index: 100;
/*	border-style: solid; border-width: 1px;*/

}

.zoomButton {
	width: 20px ;
	height: 20px;
	font-size: 20pt;
	opacity: .8
}

</style>
